module.exports = __webpack_public_path__ + "img/logo-plein-sud.4a49e0fe.jpg";